exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#compensation-app h1{font-size:1.3rem;line-height:2rem;color:#333;text-align:center}#compensation-app .short_field{max-width:300px;min-width:200px;margin:auto}#compensation-app .radio_field{text-align:center}#compensation-app .progress{height:.7rem}#compensation-app .button-group{max-width:500px;margin:auto}#compensation-app button.next,#compensation-app button.submit{float:right}#compensation-app button{color:#fff;text-align:center}#compensation-app button.active{background-color:#127198;color:#fff;font-weight:700}#compensation-app #validation_error{color:#cf2a0e;text-align:center}#compensation-app button:focus{outline:none}.redColoredText{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4443a52a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 286
// module chunks = 0